import { n } from "./property-9daa16cd.mjs";
import { e as m } from "./class-map-2994e95e.mjs";
import { o as u } from "./style-map-c3339321.mjs";
import { i as l, E as x, x as w, d as v } from "./createReactComponent-58f9bea8.mjs";
const g = l`
  :host {
    --exo-component-menu-header-overflow-y: auto;
  }

  :host .menu {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    box-sizing: border-box;
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    border-radius: var(--exo-radius-standard);
    box-shadow: var(--exo-box-shadow-moderate);
    background-color: var(--exo-color-background);
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-none);
    overflow: hidden;
    outline: none;
    font: var(--exo-doc-body-small);
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  :host .menu--width-default {
    width: var(--exo-size-3);
  }

  :host .menu.menu--width-medium {
    width: var(--exo-size-4);
  }

  :host .menu.menu--width-large {
    width: var(--exo-size-5);
  }

  :host .menu.menu--width-x-large {
    width: var(--exo-size-6);
  }
  :host .menu.menu--width-xx-large {
    width: var(--exo-size-7);
  }

  :host .menu.menu--width-fluid {
    width: 100%;
    max-width: 100%;
  }

  :host .menu.menu--width-full-fluid {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
  }

  :host .menu.menu--height-medium {
    height: var(--exo-size-2);
  }

  :host .menu.menu--height-large {
    height: var(--exo-size-3);
  }

  :host .menu--width-action-variant {
    width: 100%;
    max-width: var(--exo-size-4);
    min-width: var(--exo-size-2);
    max-height: var(--exo-size-4);
    overflow-y: var(--exo-component-menu-header-overflow-y);
  }

  ::slotted(*) {
    width: 100%;
  }

  @media only screen and (width <= 520px) {
    :host .menu:not(.menu--width-fluid) {
      max-width: 80vw;
    }
  }
`;
var c = Object.defineProperty, f = Object.getOwnPropertyDescriptor, r = (e, i, h, o) => {
  for (var s, t = o > 1 ? void 0 : o ? f(i, h) : i, d = e.length - 1; d >= 0; d--)
    (s = e[d]) && (t = (o ? s(i, h, t) : s(t)) || t);
  return o && t && c(i, h, t), t;
}, p = ((e) => (e.DEFAULT = "default", e.MEDIUM = "medium", e.LARGE = "large", e.XLARGE = "x-large", e.XXLARGE = "xx-large", e.FLUID = "fluid", e.FULLFLUID = "full-fluid", e))(p || {}), b = ((e) => (e.NAVIGATION = "navigation", e.ACTION = "action", e))(b || {}), y = ((e) => (e.DEFAULT = "default", e.MEDIUM = "medium", e.LARGE = "large", e))(y || {});
class a extends x {
  constructor() {
    super(...arguments), this.width = "default", this.height = "default", this.variant = "navigation";
  }
  render() {
    const i = this.customWidth ? { width: `${this.customWidth}px`, minWidth: "80px" } : {};
    return w`
      <div
        role="menu"
        class=${m({ menu: !0, "menu--width-default": this.width === "default" && this.variant === "navigation", "menu--width-medium": this.width === "medium" && this.variant === "navigation", "menu--width-large": this.width === "large" && this.variant === "navigation", "menu--width-x-large": this.width === "x-large" && this.variant === "navigation", "menu--width-xx-large": this.width === "xx-large" && this.variant === "navigation", "menu--width-fluid": this.width === "fluid", "menu--width-full-fluid": this.width === "full-fluid", "menu--height-medium": this.height === "medium", "menu--height-large": this.height === "large", "menu--width-action-variant": this.variant === "action" })}
        style=${u(i)}
        part="menu"
      >
        <slot class="menu--slot"></slot>
      </div>
    `;
  }
}
a.styles = g, r([n()], a.prototype, "width", 2), r([n()], a.prototype, "height", 2), r([n()], a.prototype, "variant", 2), r([n()], a.prototype, "customWidth", 2);
const D = v("ex-menu", a);
export {
  p as M,
  b as a,
  a as b,
  y as c,
  D as r
};
